import { render, staticRenderFns } from "./BrandNoticesDialog.vue?vue&type=template&id=6d781b80&scoped=true"
import script from "./BrandNoticesDialog.vue?vue&type=script&lang=js"
export * from "./BrandNoticesDialog.vue?vue&type=script&lang=js"
import style0 from "./BrandNoticesDialog.vue?vue&type=style&index=0&id=6d781b80&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d781b80",
  null
  
)

export default component.exports